/** @flow */
export default {
  en: {
    // Common
    WELCOME: "Welcome",
    WELCOME_TO_FIRSTCAREINSIGHT: "Welcome to GoodShapeCentral! Where do you want to go?",
    PLACES_TO_GO: "Places To Go",
    VIEW_MY_DETAILS: "View My Details",
    HIERARCHY: "Hierarchy",
    SERVICE: "Service",
    EMPLOYEE: "Employee",
    SIP_USER_GUIDE: "SIP User Guide",
    INCOMING_ABSENCE_CALLS: "Incoming Absence Calls",
    OUTBOUND_CALLBACKS: "Outbound Callbacks",
    DASHBOARD: "Dashboard",
    CONTACT_CENTRE_MANAGEMENT: "Contact Centre Management",
    SYSTEM_MANAGEMENT: "System Management",
    INCOMING_INTERACTION: "Incoming Interaction",
    GENESIS_CLOUD_ONLINE: "Genesys Cloud Online",
    TRAINING_ACADEMY: "Training Academy",

    ADMINISTRATION: "Administration",
    ADMINISTRATION_DESCRIPTION:
      "Administer the GoodShape service, including all {Hierarchy}, {Service}, {Employee} and {Data Admin}.",
    ADMINISTRATION_ACTION_TEXT: "Manage Service",

    RECORDING: "Recording",
    RECORDING_DESCRIPTION: "Process {Incoming Absence Calls} and complete {Outbound Callbacks}.",
    RECORDING_ACTION_TEXT: "Open Recording",

    REPORTING: "Reporting",
    REPORTING_DESCRIPTION:
      "Access the GoodShape absence reporting suite. Why not get started by visiting your {Dashboard}?",
    REPORTING_ACTION_TEXT: "Visit Dashboard",

    MANAGEMENT: "Management",
    MANAGEMENT_DESCRIPTION:
      "Carry out key GoodShape management updates, including {Contact Centre Management} and {System Management}.",
    MANAGEMENT_ACTION_TEXT: "Open Management",

    USER_SECTION_DESCRIPTION:
      "View your own absence details as well as manage your GoodShapeCentral! profile, reset your password and update your preferences.",
    GO_TO_MY_DETAILS: "Go To My Details",

    VERSION_CONTROL_VERSION_TITLE: "Version",
    VERSION_CONTROL_VERSION: "0.9.5",
    VERSION_CONTROL_DATE_TITLE: "Date Released",
    VERSION_CONTROL_DATE: "09/09/2019",
    VERSION_CONTROL_NOTES_TITLE: "Release Notes",
    VERSION_CONTROL_NOTES:
      "First release of all Absence Reason Trends and an updated version of the Absence Rate Trends which now includes trend indicators and charts.",
    VERSION_CONTOL_NOTES_ADDITIONAL:
      'In addition, absence monitoring actions can now be completed on an Employee\'s record, the missing "All" filter has been added to the Absence Details report and several new filters have been added to the employee focus list.',
    THANK_YOU_FOR_REGISTERING: "Thank you for registering!",
    YOU_ARE_ELIGIBLE: "You're now eligible to download the GoodShape app!",
    EMPLOYEE_PAGE_LIST_LINE_1: "Report, update and close absences 24/7.",
    EMPLOYEE_PAGE_LIST_LINE_2: "Access a library of wellbeing content advice.",
    EMPLOYEE_PAGE_LIST_LINE_3: "Manage your GoodShape profile.",

    EMPLOYEE_PAGE_INSTRUCTIONS:
      "Once downloaded, you can login using your GoodShape login details.",
  },
};
